export function getBasePath(): string {
  const basePath = process.env.NEXT_PUBLIC_BASE_PATH;

  if (!basePath || basePath === '/') {
    return '';
  }

  return basePath.replace(/\/$/, '');
}

export function withBasePath(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  return `${getBasePath()}${normalizedPath}`;
}
